import type { PKGNode, PKGEdge, PKGNodeEntityType, PKGEdgeType } from '@blueprint/shared';

// PKGV.B2 (#796) — standalone, decoupled subgraph->canvas mapper (V4
// adjudication, Sprint-B2-adjudication.md). Deliberately kept separate
// from any fetch/param-building logic so a later shared extraction
// (S2 follow-up, once A2 merges — tracked in #1884) is a lift-and-delete,
// not a rewrite.
//
// Field names/types mirror A2's (unmerged) fetchSubgraph.ts exactly —
// same translation, same reasoning: PKGEdge uses source/target (React
// Flow convention); the API uses fromNodeId/toNodeId (matches the
// pkg_edges column names).

export interface SubgraphApiNode {
  id: string;
  entityType: PKGNodeEntityType;
  entityId: string;
  summary: string | null;
}

export interface SubgraphApiEdge {
  id: string;
  fromNodeId: string;
  toNodeId: string;
  edgeType: PKGEdgeType;
  weight: number;
  createdByAi: boolean;
}

export interface SubgraphApiResponse {
  nodes: SubgraphApiNode[];
  edges: SubgraphApiEdge[];
  stats: {
    nodeCount: number;
    edgeCount: number;
    queryTimeMs: number;
    truncated?: boolean;
  };
}

export interface MappedSubgraph {
  nodes: PKGNode[];
  edges: PKGEdge[];
  truncated: boolean;
}

export function mapSubgraphResponse(raw: SubgraphApiResponse): MappedSubgraph {
  return {
    nodes: raw.nodes.map(n => ({
      id: n.id,
      entityType: n.entityType,
      entityId: n.entityId,
      summary: n.summary,
    })),
    edges: raw.edges.map(e => ({
      id: e.id,
      source: e.fromNodeId,
      target: e.toNodeId,
      edgeType: e.edgeType,
      createdByAi: e.createdByAi,
    })),
    truncated: raw.stats.truncated ?? false,
  };
}
